import { v4 as uuidv4 } from 'uuid';

const generateOrderId = () =>  Math.floor(Math.random() * 90000) + 10000;

const generateSessionId = () => uuidv4();

export default { generateOrderId, generateSessionId };